import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { SettingService } from 'src/app/data/repository/setting-repository/setting.service';
import { ProfileService } from 'src/app/data/repository/profile-repository/profile.service';
import { SnackBarService } from 'src/app/data/repository/utils-repository/snack-bar.service';
import { LoadingShared } from '../general/shared/loading-shared';
import { ShopService } from 'src/app/data/repository/shop-repository/shop.service';
import { ProfileShared } from '../general/shared/profile-shared';
import { Subscription } from 'rxjs';
import { TutorialShared } from '../general/shared/tutorial-shared';
import { TutorialService } from 'src/app/data/repository/tutorial-repository/tutorial.service';
import { ProfileAnalyticsService } from 'src/app/data/repository/analytics-repository/profile-analytics.service';
import { BlogApiService } from 'src/app/data/repository/blog-repository/blog-api.service';

declare var gtag;

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  dataIsReady = false;
  remainingSubscription = 0;
  hasNoDiet = false;
  res1 = false;
  res2 = false;

  subscription1: Subscription;

  constructor(
    private settingService: SettingService,
    private profileService: ProfileService,
    private snackBarService: SnackBarService,
    private loadingShared: LoadingShared,
    private shopService: ShopService,
    private profileShared: ProfileShared,
    private tutorialShared: TutorialShared,
    private tutorialService: TutorialService,
    private profileAnalytics: ProfileAnalyticsService,
    private planService: PlanService,
    private blogApiService: BlogApiService
  ) {
    this.subscription1 = this.profileShared.profileTabSelectedObs$.subscribe(
      (selected) => {
        if (selected) {
          this.load();
        }
      }
    );
  }

  async ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
  }

  async load() {
    this.profileAnalytics.analyticProfileVisited();
    this.loadingShared.showLoading();
    this.profileService.getUser().then((res) => {
      if (!res.isSuccess()) {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      } else {
        this.dataIsReady = true;
      }
      this.res1 = true;
      if (this.res1 && this.res2) {
        this.tutorial();
        this.loadingShared.hideLoading();
      }
    });
    this.planService.getDiets().then((res) => {
      if (res.isSuccess()) {
        // console.log('kkkk', res)
        if (res.getData().getDiets().length === 0) {
          this.hasNoDiet = true;
        }
      } else {
        this.hasNoDiet = true;
      }
    });
    this.shopService.getPlanSubscription(false).then((res) => {
      if (res.isSuccess()) {
        this.remainingSubscription = res
          .getData()
          .getPlanSubscription().remainingDays;
        // console.log('remain', this.remainingSubscription)
      } else {
        this.snackBarService.showSnackBar('خطا در برقراری ارتباط با سرور!');
      }
      this.res2 = true;
      if (this.res1 && this.res2) {
        this.tutorial();
        this.loadingShared.hideLoading();
      }
    });
  }

  tutorial() {
    setTimeout(() => {
      this.tutorialShared.settingBox = document.getElementById('setting-box');
      this.tutorialShared.reportsBox = document.getElementById('reports-box');
      this.tutorialService.checkProfileTutorial();
    }, 350);
  }

  goToSetting() {
    this.settingService.goToSetting();
  }

  goToShop() {
    this.shopService.goToShopPage('profile');
  }

  goToReferral() {
    this.profileService.goToReferral();
  }

  goToBarChart() {
    this.profileAnalytics.analyticProfileWaterHistoryVisited();
    this.profileService.goToProfileWaterChart();
  }

  goToDetail() {
    if (!this.hasNoDiet) {
      this.profileAnalytics.analyticProfileDietHistoryVisited();
      this.profileService.goToDietDetail();
    }
  }

  goToLineChart() {
    this.profileAnalytics.analyticProfileWeightHistoryVisited();
    this.profileService.goToProfileWeightChart();
  }
}
